import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { axiosInstance, BASE_API_CONFIG } from '../../util/Api';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined, LeftOutlined, LoadingOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { Alert, Button, Card, Col, Dropdown, Form, message, Row, Select, Spin, Table, Tooltip,Tabs, InputNumber } from 'antd';
import { format } from 'date-fns';
import { isValidString } from '../../util/ApiHelper';
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { labelComponent } from '../../util/UtilComponents';
import { Modal, Input, DatePicker } from 'antd';
import moment from 'moment';
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";

const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

const Updatefreightexporter = () => {
  const authUser = useSelector(({ auth }) => auth.userData);
  const countries = useSelector(({ common }) => common.countries);
  console.log("authUser", authUser.portPairs)
  const loadingPort =authUser.loadingPort;
  const [freightRates, setFreightRates] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const initialPortsSet = useRef(false);
  const [originalFreightRates, setOriginalFreightRates] = useState([]);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [filteredFreightRates, setFilteredFreightRates] = useState([]);

  const [enquiryPorts, setEnquiryPorts] = useState({
    loadingPorts: [],
    destinationPorts: []
  });
  const [isBookingModalVisible, setIsBookingModalVisible] = useState(false);
  const [isNegotiableModalVisible, setIsNegotiableModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  // const [bookingLoading, setBookingLoading] = useState(false);
  const [negotiableLoading, setNegotiableLoading] = useState(false);
  const [bookingForm] = Form.useForm();
  const [negotiableForm] = Form.useForm();
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [myBookings, setMyBookings] = useState([]);
  const [activeTab, setActiveTab] = useState('freightRates');
   const [freightPagination, setFreightPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0
  });
  const { isMobile } = useGetBreakpoints();
  const [bookingsPagination, setBookingsPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
const description =`Add your Loading and Destination Ports to display the latest freight rates `;
console.log("enquiryPorts",enquiryPorts)
// const [freightLoading, setFreightLoading] = useState(false);

const fetchMyBookings = async () => {
    try {
      setBookingsLoading(true);
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/updates-freight-rates/my-bookings/${authUser.id}`
      );
      const bookingsData = response.data || [];
      setMyBookings(bookingsData);
      
      setBookingsPagination(prev => ({
        ...prev,
        total: bookingsData.length
      }));
    } catch (error) {
      console.error('Error fetching bookings:', error);
      message.error('Failed to load your bookings');
    } finally {
      setBookingsLoading(false);
    }
  };

  useEffect(() => {
    if (authUser?.id) {
      fetchMyBookings();
    }
  }, [authUser?.id]);


  useEffect(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const filtered = freightRates.filter(rate => {
    if (!rate.expectedDepartureDate) return false;
    
    try {
      const etdDate = new Date(rate.expectedDepartureDate);
      etdDate.setHours(0, 0, 0, 0);
      return etdDate >= today;
    } catch (error) {
      return false;
    }
  });
  
  setFilteredFreightRates(filtered);
}, [freightRates]);


 const handleDeleteBooking = async (bookingId) => {
    try {
      await axiosInstance.delete(
        `${BASE_API_CONFIG.baseURL}/updates-freight-rates/bookings/${bookingId}`
      );
      message.success('Booking deleted successfully');
      fetchMyBookings();
    } catch (error) {
      console.error('Error deleting booking:', error);
      message.error('Failed to delete booking');
    }
  };


  const handleFreightPaginationChange = (page, pageSize) => {
  setFreightPagination({
    current: page,
    pageSize: pageSize,
    total: freightRates.length
  });
};

  useEffect(() => {
    if (myBookings.length > 0) {
        setBookingsPagination(prev => ({
            ...prev,
            total: myBookings.length
        }));
    }
}, [myBookings]);

// Handle Book Button
const handleRequestToBook = useCallback((record) => {
    setSelectedRecord(record);
    setIsBookingModalVisible(true);
    
    bookingForm.setFieldsValue({
      productName:'',
      containerType: record.containerType || '',
      numberOfContainers: 1,
      netWeightPerContainer:'',
      cargoReadinessDate: null,
      specialRequirements: ''
    });
  }, [bookingForm]);

// Handle Negotiable Button
const handleRequestToNegotiate = useCallback((record) => {
    setSelectedRecord(record);
    setIsNegotiableModalVisible(true);
    
    negotiableForm.setFieldsValue({
      productName:'',
      containerType: record.containerType || '',
      numberOfContainers: 1,
      netWeightPerContainer:'',
      cargoReadinessDate: null,
      currency: 'USD',
      rateindication: '',
      specialRequirements: ''
    });
  }, [negotiableForm]);

  const handleBookingSubmit = async (values) => {
  try {
    // setBookingLoading(true);
    
    const bookingData = {
      ...values,
      freightRateId: selectedRecord.id || selectedRecord.userid,
      loadingPort: selectedRecord.loadingPort,
      destinationPort: selectedRecord.destinationPort,
      freightRate: selectedRecord.oceanfreight,
      currency: selectedRecord.currency,
      companyName: selectedRecord.comapanyName,
      postedBy: selectedRecord.username,
      postedByUserId: selectedRecord.userid,
      requestedBy: authUser.name,
      requestedByUserId: authUser.id,
      requestedByCompany: authUser.companyName,
      cargoReadinessDate: values.cargoReadinessDate ? values.cargoReadinessDate.format('YYYY-MM-DD') : null,
      status: 'pending',
      bookingType: 'direct', // Mark as direct booking
      createdAt: new Date().toISOString()
    };

    const response = await axiosInstance.post(
      `${BASE_API_CONFIG.baseURL}/updates-freight-rates/freight-bookings`,
      bookingData
    );

    if (response.status === 201) {
      message.success('Booking request submitted successfully!');
      setIsBookingModalVisible(false);
      bookingForm.resetFields();
      setSelectedRecord(null);
    }
    fetchMyBookings();
      
    setBookingsLoading(true);
  } catch (error) {
    console.error('Booking submission error:', error);
    console.error('Error response:', error.response);
    message.error('Failed to submit booking request. Please try again.');
  } finally {
    // setBookingLoading(false);
  }
};

// Handle Negotiable Submission
// Handle Negotiable Submission



// Add this function near the top of your component, after imports
const filterByVesselETD = (rates) => {
  if (!Array.isArray(rates)) return [];
  
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Start of today
  
  return rates.filter(rate => {
    if (!rate.expectedDepartureDate) return false;
    
    try {
      const etdDate = new Date(rate.expectedDepartureDate);
      etdDate.setHours(0, 0, 0, 0);
      
      // Only include if ETD is today or in the future
      return etdDate >= today;
    } catch (error) {
      console.error('Error parsing ETD date:', error);
      return false; // Exclude if date is invalid
    }
  });
};


const handleNegotiableSubmit = async (values) => {
  try {
    setNegotiableLoading(true);
    
    const negotiableData = {
      ...values,
      freightRateId: selectedRecord.id || selectedRecord.userid,
      loadingPort: selectedRecord.loadingPort,
      destinationPort: selectedRecord.destinationPort,
      // Send BOTH the original rate and the indicated rate
      freightRate: selectedRecord.oceanfreight, // Original rate from the listing
      currency: selectedRecord.currency, // Original currency from the listing
      companyName: selectedRecord.comapanyName,
      postedBy: selectedRecord.username,
      postedByUserId: selectedRecord.userid,
      requestedBy: authUser.name,
      requestedByUserId: authUser.id,
      requestedByCompany: authUser.companyName,
      cargoReadinessDate: values.cargoReadinessDate ? values.cargoReadinessDate.format('YYYY-MM-DD') : null,
      status: 'pending',
      bookingType: 'negotiable', // Mark as negotiable booking
      rateindication: values.rateindication, // User's proposed rate
      rateindicationCurrency: values.currency, // Currency for proposed rate
      productName: values.productName,
      containerType: values.containerType,
      numberOfContainers: values.numberOfContainers,
      netWeightPerContainer: values.netWeightPerContainer,
      specialRequirements: values.specialRequirements,
      createdAt: new Date().toISOString()
    };

    console.log('Submitting negotiable booking:', negotiableData);

    const response = await axiosInstance.post(
      `${BASE_API_CONFIG.baseURL}/updates-freight-rates/freight-bookings`,
      negotiableData
    );

    if (response.status === 201) {
      message.success('Negotiation request submitted successfully!');
      setIsNegotiableModalVisible(false);
      negotiableForm.resetFields();
      setSelectedRecord(null);
    }
    fetchMyBookings();
      
    setBookingsLoading(true);
  } catch (error) {
    console.error('Negotiable submission error:', error);
    console.error('Error response:', error.response);
    message.error('Failed to submit negotiation request. Please try again.');
  } finally {
    setNegotiableLoading(false);
  }
};

  const handleBookingCancel = () => {
    setIsBookingModalVisible(false);
    bookingForm.resetFields();
    setSelectedRecord(null);
  };

  const handleNegotiableCancel = () => {
    setIsNegotiableModalVisible(false);
    negotiableForm.resetFields();
    setSelectedRecord(null);
  };

  const handleBookingsPaginationChange = (page, pageSize) => {
    setBookingsPagination({
      current: page,
      pageSize: pageSize,
      total: myBookings.length
    });
  };

 const getPaginatedFreightRates = (data = filteredFreightRates) => {
  const startIndex = (freightPagination.current - 1) * freightPagination.pageSize;
  const endIndex = startIndex + freightPagination.pageSize;
  return data.slice(startIndex, endIndex);
};

  const getPaginatedBookings = () => {
    const startIndex = (bookingsPagination.current - 1) * bookingsPagination.pageSize;
    const endIndex = startIndex + bookingsPagination.pageSize;
    return myBookings.slice(startIndex, endIndex);
  };

  const bookingsColumns = [
   {
  title: <span style={{ fontWeight: "bold" }}>Booking Date</span>,
  dataIndex: 'createdAt',
  key: 'createdAt',
  render: (text) => text ? format(new Date(text), 'dd/MM/yy') : '-',
},
 {
      title: <span style={{ fontWeight: "bold" }}>Booking Type</span>,
      dataIndex: 'bookingType',
      key: 'bookingType',
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Loading Port</span>,
      key: 'loadingPort',
      render: (_, record) => (
        <span>
          {record.loadingPort}
        </span>
      ),
    },
     {
      title: <span style={{ fontWeight: "bold" }}>Destination Port</span>,
      key: 'destinationPort',
      render: (_, record) => (
        <span>
          {record.destinationPort}
        </span>
      ),
    },
      {
      title: <span style={{ fontWeight: "bold" }}>Quantity</span>,
      dataIndex: 'numberOfContainers',
      key: 'numberOfContainers',
      render: (text) => `${text} containers`,
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Freight Rate</span>,
      key: 'freightRate',
      render: (_, record) => {
        const formattedFreight = new Intl.NumberFormat('en-IN', {
          style: 'decimal',
        }).format(record.freightRate);
        return ` ${record.currency} ${formattedFreight} `;
      },},
    // {
    //   title: <span style={{ fontWeight: "bold" }}>Container Type</span>,
    //   dataIndex: 'containerType',
    //   key: 'containerType',
    // },
    // {
    //   title: <span style={{ fontWeight: "bold" }}>Cargo Ready</span>,
    //   dataIndex: 'cargoReadinessDate',
    //   key: 'cargoReadinessDate',
    //   render: (text) => text ? format(new Date(text), 'dd/MM/yy') : '-',
    // },
    // {
    //   title: <span style={{ fontWeight: "bold" }}>Type</span>,
    //   dataIndex: 'bookingType',
    //   key: 'bookingType',
    //   render: (type) => (
    //     <span
    //       style={{
    //         color: type === 'direct' ? 'green' : 'blue',
    //         fontSize: '12px',
    //         fontWeight: '500',
    //         border: '1px solid',
    //         borderRadius: '4px',
    //         padding: '2px 8px',
    //       }}
    //     >
    //       {type?.toUpperCase()}
    //     </span>
    //   ),
    // },
    {
      title: <span style={{ fontWeight: "bold" }}>Status</span>,
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <span
          style={{
            color: status === 'confirmed' ? 'green' : 
                   status === 'cancelled' ? 'red' : 
                   status === 'negotiation_pending' ? 'orange' : 'orange',
            fontSize: '12px',
            fontWeight: '500',
            border: '1px solid',
            borderRadius: '4px',
            padding: '2px 8px',
          }}
        >
          {status?.replace('_', ' ')?.toUpperCase()}
        </span>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Actions</span>,
      key: "actions",
      render: (record) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Tooltip title="View Details">
            <Button
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => handleViewBookingDetails(record)}
            />
          </Tooltip>
          {(record.status === 'pending' || record.status === 'negotiation_pending') && (
            <Tooltip title="Delete">
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => handleDeleteBooking(record.id)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
const handleViewBookingDetails = (booking) => {
  const statusColors = {
    approved: '#52c41a',
    rejected: '#ff4d4f', 
    pending: '#faad14',
    confirmed: '#1890ff',
    cancelled: '#d9d9d9',
    negotiation_pending: '#fa8c16'
  };
  
  console.log("booking", booking)

  Modal.info({
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
        <span style={{fontSize: '20px', fontWeight: '600'}}>Request Details</span>
        <span 
          style={{
            color: statusColors[booking.status] || '#faad14',
            fontSize: '12px',
            fontWeight: '600',
            padding: '2px 8px',
            border: `1px solid ${statusColors[booking.status]}30`,
            borderRadius: '4px'
          }}
        >
          {booking.status?.replace('_', ' ')?.toUpperCase()}
        </span>
        {booking.bookingType === 'negotiable' && (
          <span 
            style={{
              color: '#1890ff',
              fontSize: '12px',
              fontWeight: '600',
              padding: '2px 8px',
              border: '1px solid #1890ff30',
              borderRadius: '4px'
            }}
          >
            RATE NEGOTIATION
          </span>
        )}
        {booking.bookingType === 'direct' && (
          <span 
            style={{
              color: '#52c41a',
              fontSize: '12px',
              fontWeight: '600',
              padding: '2px 8px',
              border: '1px solid #52c41a30',
              borderRadius: '4px'
            }}
          >
            BOOKING
          </span>
        )}
      </div>
    ),
    width: 600,
    okText: 'Close',
    content: (
      <div style={{ padding: '16px 0' }}>
        
        {/* Main Route Info */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '24px',
          padding: '16px',
          backgroundColor: '#fafafa',
          borderRadius: '6px'
        }}>
          <div style={{ fontSize: '16px', fontWeight: '600', color: '#262626' }}>
            {booking.loadingPort} → {booking.destinationPort}
          </div>
          
          {/* Rate Display based on Request Type */}
          {booking.bookingType === 'negotiable' && booking.rateindication ? (
            <>
              <div style={{ fontSize: '16px', color: '#52c41a', marginTop: '8px', fontWeight: '500' }}>
                Requested Rate: {booking.currency} {new Intl.NumberFormat('en-IN').format(booking.rateindication)}
              </div>
              <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                Original Rate: {booking.originalCurrency || booking.currency} {new Intl.NumberFormat('en-IN').format(booking.originalFreightRate || booking.freightRate)}
              </div>
            </>
          ) : (
            <div style={{ fontSize: '16px', color: '#1890ff', marginTop: '8px', fontWeight: '500' }}>
              Rate: {booking.currency} {new Intl.NumberFormat('en-IN').format(booking.freightRate)}
            </div>
          )}
        </div>

        {/* Show Rejection Reason only for cancelled bookings */}
        {booking.status === 'cancelled' && booking.Rejectionreason && (
          <div style={{ 
            marginBottom: '16px',
            padding: '12px',
            backgroundColor: '#fff2f0',
            border: '1px solid #ffccc7',
            borderRadius: '6px'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              marginBottom: '4px' 
            }}>
              <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
              <span style={{ fontWeight: '600', color: '#ff4d4f' }}>
                Cancellation Reason
              </span>
            </div>
            <div style={{ color: '#d4380d', marginLeft: '24px' }}>
              {booking.Rejectionreason}
            </div>
          </div>
        )}

        {/* All Details Grid */}
        <div style={{ display: 'grid', gap: '12px' }}>
          <DetailRow label="Request Type" value={booking.bookingType === 'negotiable' ? 'Rate Negotiation' : 'Booking'} />
          <DetailRow label="Product Name" value={booking.productName || '-'} />
          <DetailRow label="Container Type" value={booking.containerType || '-'} />
          <DetailRow label="Quantity" value={`${booking.numberOfContainers || 0} containers`} />
          <DetailRow label="Net Weight Per Container" value={`${booking.netWeightPerContainer || 0} kg`} />
          <DetailRow label="Cargo Readiness Date" value={booking.cargoReadinessDate ? format(new Date(booking.cargoReadinessDate), 'dd MMM yyyy') : '-'} />
          <DetailRow label="Requested On" value={booking.createdAt ? format(new Date(booking.createdAt), 'dd MMM yyyy') : '-'} />
          
          {/* Show Company Details if available */}
          {booking.companyName && (
            <DetailRow label="Forwarder Company" value={booking.companyName} />
          )}
          {booking.postedBy && (
            <DetailRow label="Forwarder Name" value={booking.postedBy} />
          )}
          
          {/* Show Requested By details */}
          {booking.requestedBy && (
            <DetailRow label="Requested By" value={booking.requestedBy} />
          )}
          {booking.requestedByCompany && (
            <DetailRow label="Requested Company" value={booking.requestedByCompany} />
          )}
          
          {booking.specialRequirements && (
            <DetailRow label="Special Requirements" value={booking.specialRequirements} />
          )}
        </div>

        {/* Footer */}
        <div style={{ 
          marginTop: '20px', 
          paddingTop: '12px', 
          borderTop: '1px solid #f0f0f0',
          fontSize: '12px',
          color: '#8c8c8c',
          textAlign: 'center'
        }}>
          Request ID: {booking.id}
        </div>
      </div>
    ),
  });
};

// Helper component for DetailRow


const DetailRow = ({ label, value }) => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0'
  }}>
    <span style={{ color: '#666', fontWeight: '500' }}>{label}:</span>
    <span style={{ color: '#262626', fontWeight: '600' }}>{value}</span>
  </div>
);

  const handleEditBooking = (booking) => {
    message.info('Edit functionality to be implemented');
  };

  useEffect(() => {
    if (activeTab === 'myBookings' && authUser?.id) {
      fetchMyBookings();
    }
  }, [activeTab, authUser?.id]);

    const fetchEnquiryPorts = async (userId) => {
         try {
          console.log("userId---->freight market watch",userId)
           const response = await axiosInstance.get(
             `${BASE_API_CONFIG.baseURL}/updates-freight-rates/enquiries/user/${userId}/ports`
           );
           
           const uniqueLoadingPorts = [...new Set(response.data.loadingPorts)]
             .filter(port => port);
           
           const uniqueDestinationPorts = [...new Set(response.data.destinationPorts)]
             .filter(port => port);
           
           return {
             loadingPorts: uniqueLoadingPorts,
             destinationPorts: uniqueDestinationPorts
           };
         } catch (error) {
           console.error('Error fetching enquiry ports:', error);
           return {
             loadingPorts: [],
             destinationPorts: []
           };
         }
       };

const { loadingPorts, destinationPorts, portsAvailable } = useMemo(() => {
  try {
    const userLoadingPorts = authUser?.loadingPort
      ? typeof authUser.loadingPort === 'string'
        ? JSON.parse(authUser.loadingPort)
        : authUser.loadingPort
      : [];

    const userDestinationPorts = authUser?.port
      ? typeof authUser.port === 'string'
        ? JSON.parse(authUser.port)
        : authUser.port
      : [];

   const deduplicatePorts = (ports) => {
  const seen = new Map();

  return ports.filter(port => {
    if (!port) return false;
    const [baseName, hscode] = port.split(/[()]+/).map(s => s.trim());
    const key = hscode ? `${baseName}|${hscode}` : baseName;
    if (seen.has(key)) return false;

    if (!hscode && seen.has(`${baseName}|*`)) return false;
    seen.set(key, true);
    if (hscode) seen.set(`${baseName}|*`, true);

    return true;
  });
};

    const combinedLoadingPorts = deduplicatePorts([
      ...userLoadingPorts,
      ...enquiryPorts.loadingPorts
    ]);

     const combinedDestinationPorts = deduplicatePorts([
      ...userDestinationPorts,
      ...enquiryPorts.destinationPorts
    ]);
console.log("combinedLoadingPorts",combinedLoadingPorts)
    return {
      loadingPorts: combinedLoadingPorts,
      destinationPorts: combinedDestinationPorts,
      portsAvailable: combinedLoadingPorts.length > 0 || combinedDestinationPorts.length > 0
    };
  } catch (e) {
    return { loadingPorts: [], destinationPorts: [], portsAvailable: false };
  }
}, [authUser, enquiryPorts]);

const parsePortPairs = (portPairs) => {
  if (!portPairs || !Array.isArray(portPairs)) return { loadingPorts: [], portMap: {} };
  
  const loadingPorts = [];
  const portMap = {};

  portPairs.forEach(pair => {
    const separator = pair.includes('→') ? '→' : '->';
    const [loadingPart, destinationPart] = pair.split(separator).map(part => part.trim());
    
    if (loadingPart && destinationPart) {
      if (!loadingPorts.includes(loadingPart)) {
        loadingPorts.push(loadingPart);
      }
      
      if (!portMap[loadingPart]) {
        portMap[loadingPart] = [];
      }
      if (!portMap[loadingPart].includes(destinationPart)) {
        portMap[loadingPart].push(destinationPart);
      }
    }
  });

  return { loadingPorts, portMap };
};

  const { loadingPorts: userLoadingPorts, portMap } = useMemo(() => 
    parsePortPairs(authUser.portPairs), 
    [authUser.portPairs]
  );

  const [selectedLoadingPort, setSelectedLoadingPort] = useState('');
  const [availableDestinationPorts, setAvailableDestinationPorts] = useState([]);

  useEffect(() => {
    if (selectedLoadingPort && portMap[selectedLoadingPort]) {
      setAvailableDestinationPorts(portMap[selectedLoadingPort]);
      form.setFieldsValue({ destinationPort: portMap[selectedLoadingPort][0] || '' });
    } else {
      setAvailableDestinationPorts([]);
      form.setFieldsValue({ destinationPort: '' });
    }
  }, [selectedLoadingPort, portMap, form]);

  useEffect(() => {
  if (userLoadingPorts.length > 0 && !selectedLoadingPort) {
    const initialLoadingPort = userLoadingPorts[0];
    const initialDestinationPort = portMap[initialLoadingPort]?.[0] || '';
    
    setSelectedLoadingPort(initialLoadingPort);
    form.setFieldsValue({ 
      loadingPort: initialLoadingPort,
      destinationPort: initialDestinationPort
    });
  }
}, [userLoadingPorts, portMap, form, selectedLoadingPort]);

 const handleViewDetails = useCallback((record) => {
      history.push({
        pathname: `/freight-market-watch-Details/${id}`,
        state: { freightRate: record },
      });
    }, [history]);

const renderMobileView = useCallback((data, isBookings = false) => {

  const displayData = isBookings ? data : data.filter(rate => {
    if (!rate.expectedDepartureDate) return false;
    
    try {
      const etdDate = new Date(rate.expectedDepartureDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      etdDate.setHours(0, 0, 0, 0);
      
      return etdDate >= today;
    } catch (error) {
      return false;
    }
  });

  if (isBookings) {
    return displayData.map((record) => (
      <Card
        key={record.id}
        style={{ marginBottom: 16 }}
        bodyStyle={{ padding: 16 }}
      >
        <div onClick={() => handleViewBookingDetails(record)} style={{ cursor: 'pointer' }}>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: 10,
            padding: 10,
            backgroundColor: '#188fff25',
            borderRadius: '6px'
          }}>
            <div style={{ fontSize: 12, fontWeight: '600', color: '#262626' }}>
              {record.loadingPort} → {record.destinationPort}
            </div>
            <div style={{ fontSize: 12,fontWeight: '600', color: '#1890ff', marginTop: 4 }}>
              {new Intl.NumberFormat('en-IN').format(record.freightRate)} {record.currency}
            </div>
            {record.bookingType === 'negotiable' && (
              <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>
                Your Offer: {record.currency} {new Intl.NumberFormat('en-IN').format(record.rateindication)}
              </div>
            )}
          </div>

          <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
            <Col span={12}>
              <div style={{ color: '#666', fontSize: 12 }}>Booking Date</div>
              <div style={{ fontWeight: '600', fontSize: 13 }}>
                {record.createdAt ? format(new Date(record.createdAt), 'dd-MMM-yyyy') : '-'}
              </div>
            </Col>
            <Col span={12}>
              <div style={{ color: '#666', fontSize: 12 }}>Container Type</div>
              <div style={{ fontWeight: '600', fontSize: 13 }}>{record.containerType}</div>
            </Col>
          </Row>

          <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
            <Col span={12}>
              <div style={{ color: '#666', fontSize: 12 }}>Quantity</div>
              <div style={{ fontWeight: '600', fontSize: 13 }}>
                {record.numberOfContainers} containers
              </div>
            </Col>
            <Col span={12}>
              <div style={{ color: '#666', fontSize: 12 }}>Cargo Ready</div>
              <div style={{ fontWeight: '600', fontSize: 13 }}>
                {record.cargoReadinessDate ? format(new Date(record.cargoReadinessDate), 'dd-MMM-yyyy') : '-'}
              </div>
            </Col>
          </Row>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={{ color: '#666', fontSize: 12 }}>Type</div>
            <span
              style={{
                color: record.bookingType === 'direct' ? 'green' : 'blue',
                fontSize: 11,
                fontWeight: '600',
                border: '1px solid',
                borderRadius: '4px',
                padding: '2px 8px',
              }}
            >
              {record.bookingType?.toUpperCase()}
            </span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div style={{ color: '#666', fontSize: 12 }}>Status</div>
            <span
              style={{
                color: record.status === 'confirmed' ? 'green' : 
                       record.status === 'rejected' ? 'red' : 
                       record.status === 'negotiation_pending' ? 'orange' : 'orange',
                fontSize: 11,
                fontWeight: '600',
                border: '1px solid',
                borderRadius: '4px',
                padding: '2px 8px',
              }}
            >
              {record.status?.replace('_', ' ')?.toUpperCase()}
            </span>
          </div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <Tooltip title="View Details">
              <Button
                type="primary"
                size="small"
                icon={<EyeOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewBookingDetails(record);
                }}
              />
            </Tooltip>
            {(record.status === 'pending' || record.status === 'negotiation_pending') && (
              <Tooltip title="Delete">
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteBooking(record.id);
                  }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      </Card>
    ));
  }

  return displayData.map((record) => (
    <Card
      key={record.userid}
      style={{ marginBottom: 16 }}
      bodyStyle={{ padding: 16 }}
      onClick={() => handleViewDetails(record)}
    >
      <div style={{ 
        textAlign: 'center', 
        marginBottom: 16,
        padding: 12,
        backgroundColor: '#f0f8ff',
        borderRadius: '6px'
      }}>
        <div style={{ fontSize: 16, fontWeight: '600', color: '#262626' }}>
          {record.loadingPort} → {record.destinationPort}
        </div>
        <div style={{ fontSize: 18, color: '#1890ff', marginTop: 4, fontWeight: 'bold' }}>
          {new Intl.NumberFormat('en-IN').format(record.oceanfreight)} {record.currency}
        </div>
      </div>

      <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
        <Col span={12}>
          <div style={{ color: '#666', fontSize: 12 }}>Posted Date</div>
          <div style={{ fontWeight: '600', fontSize: 13 }}>
            {record.createdAt ? format(new Date(record.createdAt), 'dd-MMM-yyyy') : '-'}
          </div>
        </Col>
        <Col span={12}>
          <div style={{ color: '#666', fontSize: 12 }}>Container Type</div>
          <div style={{ fontWeight: '600', fontSize: 13 }}>{record.containerType}</div>
        </Col>
      </Row>

      <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <div style={{ color: '#666', fontSize: 12 }}>Price Validity</div>
          <div style={{ fontWeight: '600', fontSize: 13 }}>
            {record.pricevalidity ? format(new Date(record.pricevalidity), 'dd-MMM-yyyy') : '-'}
          </div>
        </Col>
        <Col span={12}>
          <div style={{ color: '#666', fontSize: 12 }}>Posted By</div>
          <div style={{ fontWeight: '600', fontSize: 13 }}>{record.username || 'Unknown'}</div>
        </Col>
      </Row>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
        <Button
          type="primary"
          size="large"
          onClick={(e) => {
            e.stopPropagation();
            handleRequestToBook(record);
          }}
          style={{
            backgroundColor: '#1890ff',
            borderColor: '#1890ff',
            fontWeight: '600',
            flex: 1
          }}
        >
          Book
        </Button>
        <Button
          type="default"
          size="large"
          onClick={(e) => {
            e.stopPropagation();
            handleRequestToNegotiate(record);
          }}
          style={{
            backgroundColor: '#52c41a',
            borderColor: '#52c41a',
            color: 'white',
            fontWeight: '600',
            flex: 1
          }}
        >
          Negotiate
        </Button>
      </div>
    </Card>
  ));
}, [handleViewBookingDetails, handleDeleteBooking, handleViewDetails, handleRequestToBook, handleRequestToNegotiate]);

const defaultLoadingPort = loadingPorts[0] || '';
const defaultDestinationPort = destinationPorts[0] || '';

const [portCount, setPortCount] = useState(0);

const fetchFreightRatesForAllPorts = async () => {
  try {
    setError(null);
    
    if (!userLoadingPorts || userLoadingPorts.length === 0 || !portMap) {
      setFreightRates([]);
      return;
    }

    const allRates = [];
    
    for (const loadingPort of userLoadingPorts) {
      const destinationPorts = portMap[loadingPort] || [];
      
      for (const destinationPort of destinationPorts) {
        try {
          const encodedLoadingPort = encodeURIComponent(loadingPort);
          const encodedDestinationPort = encodeURIComponent(destinationPort);
          
          const response = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/updates-freight-rates/${encodedDestinationPort}/${encodedLoadingPort}`
          );
          
          if (response.data && response.data.rows && response.data.rows.length > 0) {
            const ratesWithPortInfo = response.data.rows.map(rate => ({
              ...rate,
              loadingPort,
              destinationPort,
              portPair: `${loadingPort} → ${destinationPort}`
            }));
            
            allRates.push(...ratesWithPortInfo);
          }
        } catch (error) {
          console.error(`Error fetching rates for ${loadingPort} → ${destinationPort}:`, error);
        }
      }
    }
    
    // Filter rates by ETD date before sorting
    const filteredRates = filterByVesselETD(allRates);
    
    const sortedRates = filteredRates.sort((a, b) => {
      // Sort by ETD date (closest first), then by price
      const dateA = new Date(a.expectedDepartureDate);
      const dateB = new Date(b.expectedDepartureDate);
      
      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;
      
      // If same ETD, sort by price (lowest first)
      return parseFloat(a.oceanfreight) - parseFloat(b.oceanfreight);
    });
    
    setFreightRates(sortedRates);
    setOriginalFreightRates(sortedRates);
    
  } catch (error) {
    console.error('Error fetching all freight rates:', error);
    setError('Failed to load freight rates');
    setFreightRates([]);
  }
};

  const fetchAllFreightRates = async (destinationPort) => {
    console.log("destinationPortdestinationPort",destinationPort)
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/updates-freight-rates/${destinationPort}`,
        {
          "rows": [
            {
              "loadingPort": "",
              "destinationPort": "",
            }
          ]
        },
      );
      return response.data.rows ||[];
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data');
    }
  };

  useEffect(() => {
    if (defaultLoadingPort && defaultDestinationPort && originalFreightRates.length > 0) {
      form.setFieldsValue({
        loadingPort: defaultLoadingPort,
        destinationPort: defaultDestinationPort
      });
      form.submit();
    }
  }, [defaultLoadingPort, defaultDestinationPort, originalFreightRates, form]);

  useEffect(() => {
    const loadInitialData = async () => {
      dispatch(fetchStart());
      // setFreightLoading(true)
      
      try {
        const enquiryPortsData = await fetchEnquiryPorts(authUser.id);
        setEnquiryPorts(enquiryPortsData);
        await fetchFreightRatesForAllPorts();
        
      } catch (error) {
        console.error('Initial data loading error:', error);
        setError('Failed to load initial data');
      } finally {
      // setFreightLoading(false);
        dispatch(fetchSuccess());
      }
    };

    if (authUser?.id && authUser?.portPairs) {
      loadInitialData();
    } else {
      // setFreightLoading(false);
      setFreightRates([]);
    }
  }, [authUser, dispatch]);

   const navigateToDetails = useCallback(
      (destinationPort) => {
        if (isValidString(destinationPort) && isValidString(destinationPort)) {
          history.push(`freight-market-watch/freight-market-watch-details`);
        } else if (isValidString(destinationPort)) {
          history.push(`freight-market-watch/freight-market-watch-details`);
        }
      },
      [history]
    );

    const id =authUser.id;

    const handleViewMoreQuotes = useCallback(async () => {
      try {
        // setLoading(true);
        const data = await fetchAllFreightRates(authUser.port);
        history.push({
          pathname: '/freight-market-watch-all-details/all-quotes',
          state: { allFreightRates: data },
        });
      } catch (err) {
        setError(err.message || 'Failed to load freight rates');
      } finally {
        // setLoading(false);
      }
    }, [authUser.port, history]);

    const normalizePortString = (port) => {
  if (!port) return '';
  return port
    .replace(/[\n\t]/g, ' ')         
    .replace(/\s+/g, ' ')             
    .replace(/\s*\(\s*/g, '(')        
    .replace(/\s*\)\s*/g, ')')
    .trim()
    .toUpperCase();
};

    const handleNavigateToProfile = () => {
      history.push('/my-profile/edit');
    };

  // Updated columns with both Book and Negotiate buttons
  const columns = [
 {
  title: <span style={{ fontWeight: "bold" }}>Vessel ETD</span>,
  dataIndex: 'expectedDepartureDate',
  key: 'expectedDepartureDate',
  render: (text) => text ? format(new Date(text), 'dd/MM/yy') : '-',
},
    {
      title: <span style={{ fontWeight: "bold" }}>Loading Port</span>,
      dataIndex: 'loadingPort',
      key: 'loadingPort',
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Destination Port</span>,
      dataIndex: 'destinationPort',
      key: 'destinationPort',
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Container Type</span>,
      dataIndex: 'containerType',
      key: 'containerType',
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Freight Rate </span>,
      key: 'freightRate',
      render: (_, record) => {
        const formattedFreight = new Intl.NumberFormat('en-IN', {
          style: 'decimal',
        }).format(record.oceanfreight);
        return ` ${record.currency} ${formattedFreight} `;
      },
    },
  
    {
      title: <span style={{ fontWeight: "bold" }}>Price Validity</span> ,
      dataIndex: 'pricevalidity',
      key: 'pricevalidity',
       render: (text) => text ? format(new Date(text), 'dd/MM/yy') : '-',
    },
    {
  title: <span style={{ fontWeight: "bold" }}>Actions</span>,
  key: "actions",
  render: (record) => (
    <div
      className="myexim-action-icon"
      onClick={(e) => e.stopPropagation()}
      style={{ display: 'flex', gap: '8px' }}
    >
      <Dropdown
        menu={{
          items: [
            {
              key: 'view-details',
              label: 'View Details',
              onClick: () => handleViewDetails(record),
            },
            {
              key: 'book',
              label: 'Book',
              onClick: () => handleRequestToBook(record),
            },
            {
              key: 'negotiate',
              label: 'Negotiate',
              onClick: () => handleRequestToNegotiate(record),
            },
          ],
        }}
        trigger={['click']}
        placement="bottomRight"
      >
        <Button
          type="text"
          size="small"
          style={{
            padding: '0 8px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#595959',
          }}
        >
          ⋮
        </Button>
      </Dropdown>
    </div>
  ),
},
  ];

  if (error) return <div>Error: {error}</div>;

  return (
    <>
    <Card
      className="myexim-detail-card"
      title={
        <div className="myexim-table-title gx-text-capitalize">
          <LeftOutlined
            className={'back-icon'}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          Freight Rates
           {portCount < 5 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px', color: '#ff4d4f' }}>
            {/* {5 - portCount}  */}
          </span>
          {/* <Button
            type="primary"
            size="small"
            onClick={handleNavigateToProfile}
            icon={<PlusOutlined />}
          >
            Add Ports
          </Button> */}
        </div>
      )}
        </div>
      }
      
    >
   <div style={{ 
  backgroundColor: '#f8f9fa',
  padding: '16px 24px',
  margin: '-16px -24px 16px -24px',
  borderBottom: '1px solid #f0f0f0'
}}>
  <div style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#1677ff",
    flexWrap: "wrap"
  }}>
    <span>
      Add your Loading and Destination Ports to get the latest freight rates uploaded by the forwarders
    </span>
    <Button 
      type="primary" 
      size="small"
      onClick={handleNavigateToProfile}
      icon={<PlusOutlined />}
      style={{ 
        flexShrink: 0,
        marginLeft: "8px"
      }}
    >
      Add Ports
    </Button>
  </div>
</div>

  <div style={{ minHeight: 300, position: 'relative' }}>
  {/* {freightLoading ? (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1,
      textAlign: 'center'
    }}>
      <Spin 
        indicator={<LoadingOutlined style={{ fontSize: 44 }} spin />}
        tip="Loading freight rates..."
        size="large"
      />
    </div>
  ) : null} */}

  {filteredFreightRates.length > 0 ? (
  isMobile ? (
    <>
      {renderMobileView(
        getPaginatedFreightRates(filteredFreightRates), // Pass filtered data
        false
      )}
      {/* rest of mobile pagination */}
    </>
  ) : (
    <Table
      rowClassName={(record, index) => 
        index % 2 === 0 ? "table-row-light" : "table-row-dark"
      }
      className="gx-table-responsive rfq-table myexim-table"
      rowKey="userid"
      dataSource={getPaginatedFreightRates(filteredFreightRates)} // Use filtered data
      columns={columns}
      pagination={{
        current: freightPagination.current,
        pageSize: freightPagination.pageSize,
        total: filteredFreightRates.length, // Update total count
        onChange: handleFreightPaginationChange,
        onShowSizeChange: handleFreightPaginationChange,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50'],
        showTotal: (total, range) => 
          `${range[0]}-${range[1]} of ${total} active freight rates`
      }}
      locale={{
        emptyText: filteredFreightRates.length === 0 && freightRates.length > 0 
          ? 'No active freight rates (all ETDs are in the past)' 
          : 'No freight rates found'
      }}
      onRow={(record) => ({
        onClick: (e) => {
          if (!e.target.classList.contains("ant-dropdown-menu-title-content")) {
            handleViewDetails(record);
          }
        }
      })}
    />
  )
) : (
  <div style={{ textAlign: 'center', padding: 20 }}>
    {freightRates.length > 0 
      ? 'No active freight rates (all vessel ETDs are in the past)' 
      : 'No freight rates found'
    }
  </div>
)}
        
    
</div>  
</Card>

<Card 
        style={{ marginTop: 24 }}
        title={
          <div className="myexim-table-title gx-text-capitalize">
           My Requests
          </div>
        }
      >
         {isMobile ? (
    <div style={{ minHeight: 200 }}>
      {bookingsLoading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin />
        </div>
      ) : myBookings.length > 0 ? (
        <>
          {renderMobileView(getPaginatedBookings(), true)}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            marginTop: 16,
            padding: '0 16px',
            gap: '8px'
          }}>
            <Button
              onClick={() => handleBookingsPaginationChange(bookingsPagination.current - 1, bookingsPagination.pageSize)}
              disabled={bookingsPagination.current === 1}
            >
              Previous
            </Button>
            <span style={{ 
              fontSize: 14,
              whiteSpace: 'nowrap'
            }}>
              Page {bookingsPagination.current} of {Math.ceil(bookingsPagination.total / bookingsPagination.pageSize)}
            </span>
            <Button
              onClick={() => handleBookingsPaginationChange(bookingsPagination.current + 1, bookingsPagination.pageSize)}
              disabled={bookingsPagination.current >= Math.ceil(bookingsPagination.total / bookingsPagination.pageSize)}
            >
              Next
            </Button>
          </div>
        </>
      ) : (
        <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
          No bookings found
        </div>
      )}
    </div>
  ) : (
    <Table
      columns={bookingsColumns}
      dataSource={getPaginatedBookings()}
      loading={bookingsLoading}
      rowKey={(record) => record.id}
      pagination={{
        current: bookingsPagination.current,
        pageSize: bookingsPagination.pageSize,
        total: bookingsPagination.total,
        onChange: handleBookingsPaginationChange,
        onShowSizeChange: handleBookingsPaginationChange,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50'],
        showTotal: (total, range) => 
          `${range[0]}-${range[1]} of ${total} bookings`
      }}
      locale={{
        emptyText: 'No bookings found'
      }}
        style={{ fontSize: '5px' }}
    />
  )}
      </Card> 

{/* Book Modal */}
<Modal
  title="Request to Book Freight"
  open={isBookingModalVisible}
  onCancel={handleBookingCancel}
  footer={null}
  width={800}
  centered
>
  <Form
    form={bookingForm}
    layout="vertical"
    onFinish={handleBookingSubmit}
    style={{ marginTop: 10 }}
  >
    <Form.Item
      label="Product Name"
      name="productName"
      rules={[
        { required: true, message: "Product name is required" },
      ]}
    >
      <Input
        placeholder="Enter product name"
        size="large"
        showCount
        maxLength={100}
      />
    </Form.Item>

    <Form.Item
      name="containerType"
      label="Container Type"
      rules={[{ required: true, message: 'Please select container type' }]}
    >
      <Select
        showSearch
        size="large"
        placeholder="Select Container Type"
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        <Option value={"20'drystandard"}>20' Dry Standard</Option>
        <Option value={"40'drystandard"}>40' Dry Standard</Option>
        <Option value={"40'dryhighcube"}>40' Dry High Cube</Option>
        <Option value={"45'dryhighcube"}>45' Dry High Cube</Option>
        <Option value={"20'reefer"}>20' Reefer</Option>
        <Option value={"40'reeferhighcube"}>40' Reefer High Cube</Option>
      </Select>
    </Form.Item>

    <Form.Item
      name="numberOfContainers"
      label="Number of Containers"
      rules={[{ required: true, message: 'Please enter number of containers' }]}
    >
      <Input 
        type="number" 
        min={1} 
        max={100}
        placeholder="Enter number of containers"
        size="large"
      />
    </Form.Item>

    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
      <div style={{ flex: 1 }}>
        <Form.Item
          label="Net Weight Per Container (kg)"
          name="netWeightPerContainer"
          rules={[
            { required: true, message: "Net weight is required" },
            { 
              type: 'number', 
              min: 0, 
              message: "Weight must be positive" 
            }
          ]}
          style={{ marginBottom: 0 }}
        >
          <InputNumber
            min={0} 
            style={{ width: "100%" }} 
            size="large"
            placeholder="Weight in kg"
          />
        </Form.Item>
      </div>
      
      <div style={{ flex: 1 }}>
        <Form.Item
          name="cargoReadinessDate"
          label="Cargo Readiness Date"
          rules={[{ required: true, message: 'Please select date' }]}
          style={{ marginBottom: 0 }}
        >
          <DatePicker 
            style={{ width: "100%" }}
            size="large"
            placeholder="Select date"
            disabledDate={(current) => current && current < moment().startOf('day')}
          />
        </Form.Item>
      </div>
    </div>

    <Form.Item
      name="specialRequirements"
      label="Special Requirements (Optional)"
    >
      <TextArea 
        rows={4}
        placeholder="Comments"
        maxLength={500}
        showCount
      />
    </Form.Item>

    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
      <Button 
        onClick={handleBookingCancel}
        style={{ marginRight: 10 }}
        size="large"
      >
        Cancel
      </Button>
      <Button 
        type="primary" 
        htmlType="submit" 
        // loading={bookingLoading}
        size="large"
      >
        Submit Booking Request
      </Button>
    </Form.Item>
  </Form>
</Modal>

{/* Negotiable Modal */}
<Modal
  title="Request to Negotiate Freight"
  open={isNegotiableModalVisible}
  onCancel={handleNegotiableCancel}
  footer={null}
  width={800}
  centered
>
  <Form
    form={negotiableForm}
    layout="vertical"
    onFinish={handleNegotiableSubmit}
    style={{ marginTop: 10 }}
  >
    <Form.Item
      label="Product Name"
      name="productName"
      rules={[
        { required: true, message: "Product name is required" },
      ]}
    >
      <Input
        placeholder="Enter product name"
        size="large"
        showCount
        maxLength={100}
      />
    </Form.Item>

    <Form.Item
      name="containerType"
      label="Container Type"
      rules={[{ required: true, message: 'Please select container type' }]}
    >
      <Select
        showSearch
        size="large"
        placeholder="Select Container Type"
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        <Option value={"20'drystandard"}>20' Dry Standard</Option>
        <Option value={"40'drystandard"}>40' Dry Standard</Option>
        <Option value={"40'dryhighcube"}>40' Dry High Cube</Option>
        <Option value={"45'dryhighcube"}>45' Dry High Cube</Option>
        <Option value={"20'reefer"}>20' Reefer</Option>
        <Option value={"40'reeferhighcube"}>40' Reefer High Cube</Option>
      </Select>
    </Form.Item>

    <Form.Item
      name="numberOfContainers"
      label="Number of Containers"
      rules={[{ required: true, message: 'Please enter number of containers' }]}
    >
      <Input 
        type="number" 
        min={1} 
        max={100}
        placeholder="Enter number of containers"
        size="large"
      />
    </Form.Item>

    <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
      <div style={{ flex: 1 }}>
        <Form.Item
          label="Net Weight Per Container (kg)"
          name="netWeightPerContainer"
          rules={[
            { required: true, message: "Net weight is required" },
            { 
              type: 'number', 
              min: 0, 
              message: "Weight must be positive" 
            }
          ]}
          style={{ marginBottom: 0 }}
        >
          <InputNumber
            min={0} 
            style={{ width: "100%" }} 
            size="large"
            placeholder="Weight in kg"
          />
        </Form.Item>
      </div>
      
      <div style={{ flex: 1 }}>
        <Form.Item
          name="cargoReadinessDate"
          label="Cargo Readiness Date"
          rules={[{ required: true, message: 'Please select date' }]}
          style={{ marginBottom: 0 }}
        >
          <DatePicker 
            style={{ width: "100%" }}
            size="large"
            placeholder="Select date"
            disabledDate={(current) => current && current < moment().startOf('day')}
          />
        </Form.Item>
      </div>
    </div>

    {/* Rate Indication Field */}
    <Form.Item
      label={
        <div>
          <div>Rate Indication</div>
          {/* <div style={{ fontSize: '12px', color: '#8c8c8c', fontWeight: 'normal' }}>
            Enter your proposed rate for negotiation
          </div> */}
        </div>
      }
      required
      style={{ marginTop: 10 }}
    >
      <Input.Group 
        compact 
        style={{ 
          display: 'flex', 
          width: '100%',
          alignItems: 'center'
        }}
      >
        <Form.Item
          name="currency"
          style={{ 
            margin: 0,
            width: '30%',
            marginRight: '8px'
          }}
          rules={[{ required: true, message: "Currency is required" }]}
        >
          <Select
            showSearch
            size="large"
            placeholder="Select Currency"
            style={{ width: '100%' }}
          >
            {countries
              ?.filter((country, index) => 
                index === countries.findIndex((o) => country.currencyCode === o.currencyCode)
              )
              .map(
                (option) =>
                  option.currencyCode && (
                    <Option key={option.id} value={option.currencyCode}>
                      {option.currencyCode}
                    </Option>
                  )
              )}
          </Select>
        </Form.Item>
        <Form.Item
          name="rateindication"
          style={{ 
            margin: 0,
            flex: 1
          }}
          rules={[{ required: true, message: "Rate indication is required" }]}
        >
          <Input
            type="number"
            min={0}
            placeholder="Enter your proposed rate"
            size="large"
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Input.Group>
    </Form.Item>

    <Form.Item
      name="specialRequirements"
      label="Special Requirements (Optional)"
    >
      <TextArea 
        rows={4}
        placeholder="Comments or negotiation details"
        maxLength={500}
        showCount
      />
    </Form.Item>

    <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
      <Button 
        onClick={handleNegotiableCancel}
        style={{ marginRight: 10 }}
        size="large"
      >
        Cancel
      </Button>
      <Button 
        type="primary" 
        htmlType="submit" 
        loading={negotiableLoading}
        size="large"
        style={{
          backgroundColor: '#52c41a',
          borderColor: '#52c41a'
        }}
      >
        Submit Negotiation Request
      </Button>
    </Form.Item>
  </Form>
</Modal>
    </>
  );
};

export default Updatefreightexporter;